import React from "react";

import { Icon } from "aible";

import styles from "./style.module.css";

export default class SenseAccordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: {} };
  }

  render() {
    const { items } = this.props;
    const { isOpen } = this.state;

    return (
      <div>
        {items &&
          items.map((item, i) => {
            const isItemOpen = isOpen?.[i];

            if (item?.isHide) {
              return <React.Fragment />;
            }

            return (
              <AccordionItem
                header={item?.header}
                onClick={() => {
                  const retIsOpen = {
                    ...isOpen,
                    [i]: !isItemOpen
                  };

                  this.setState({ isOpen: retIsOpen });
                }}
                show={isItemOpen}
                hideBorder={isItemOpen}
                isOverflowVisible={item?.isOverflowVisible && isItemOpen}
                isOverflowHidden={item?.isOverflowHidden}
                isNoMaxHeight={item?.isNoMaxHeight}
                isCenter={item?.isCenter}
                zIndex={i}
                key={i}
              >
                {item?.body}
              </AccordionItem>
            );
          })}
      </div>
    );
  }
}

class AccordionItem extends React.Component {
  state = {
    hide: !this.props.defaultShow
  };

  handleToggle() {
    const { show, onClick, onToggle } = this.props;
    const { hide } = this.state;

    if (show === undefined) {
      this.setState({ hide: !hide });
    }

    onToggle && onToggle(!hide);
    return onClick && onClick();
  }

  render() {
    const {
      className,
      bodyClass,
      show,
      defaultShow,
      header,
      hideIcon,
      shrinkHeader,
      noBot,
      onClick,
      hideBorder,
      isOverflowVisible,
      isOverflowHidden,
      isNoMaxHeight,
      isCenter,
      zIndex,
      ...retProps
    } = this.props;
    const { hide } = this.state;

    const showBody = show === undefined ? !hide : show;

    return (
      <div
        {...retProps}
        className={styles.accordionWrapper + (className ? " " + className : "")}
        style={{ zIndex: zIndex }}
      >
        <div
          className={styles.accordionHeader}
          onClick={() => this.handleToggle()}
          style={hideBorder ? { borderBottom: "1px solid transparent" } : {}}
        >
          {header}
          {!hideIcon ? (
            <div className={styles.accordionIndicator} style={shrinkHeader ? { marginLeft: "15px" } : undefined}>
              <Icon type={showBody ? "chevronUp" : "chevronDown"} />
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={
            styles.accordionBody +
            (showBody ? "" : " " + styles.hide) +
            " " +
            (bodyClass ? bodyClass : "") +
            " " +
            (isOverflowVisible ? styles.oVisible : "") +
            " " +
            (isOverflowHidden ? styles.oHidden : "") +
            " " +
            (isCenter !== false ? styles.oCenter : "") +
            " " +
            (isNoMaxHeight === true ? styles.noMaxHeight : "")
          }
          style={
            showBody
              ? {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  paddingBottom: "10px"
                }
              : { borderBottom: "1px solid transparent" }
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
